/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PageInputs */

const en_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page`)
};

const es_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

const fr_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page`)
};

const de_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite`)
};

const ja_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ページ`)
};

const zh_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页码`)
};

const ar_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصفحة`)
};

const id_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halaman`)
};

const it_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagina`)
};

const ru_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Страница`)
};

const pt_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

const ko_page = /** @type {(inputs: PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`페이지`)
};

/**
* | output |
* | --- |
* | "Page" |
*
* @param {PageInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const page = /** @type {((inputs?: PageInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PageInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page(inputs)
	if (locale === "es") return es_page(inputs)
	if (locale === "fr") return fr_page(inputs)
	if (locale === "de") return de_page(inputs)
	if (locale === "ja") return ja_page(inputs)
	if (locale === "zh") return zh_page(inputs)
	if (locale === "ar") return ar_page(inputs)
	if (locale === "id") return id_page(inputs)
	if (locale === "it") return it_page(inputs)
	if (locale === "ru") return ru_page(inputs)
	if (locale === "pt") return pt_page(inputs)
	return ko_page(inputs)
});